const es = {
  today: "Partidos de Hoy",
  live: "EN VIVO",
  upcoming: "Próximos",
  stats: "Estadísticas",
  noLive: "No hay partidos en vivo ahora",
  clickForStats: "Click para estadísticas completas",
  viewOdds: "Ver Cuotas en Vivo →",
  headToHead: "Cara a Cara",
  form: "Forma Actual",
  goalStats: "Estadísticas de Goles",
  leagueTable: "Tabla de Liga",
  injuries: "Lesiones y Suspensiones",
  outcome: "Resultado Probable",
  homeWin: "Victoria Local",
  draw: "Empate",
  awayWin: "Victoria Visitante",
  confidence: "Confianza",
  viewing: "personas viendo",
  subscribe: "Recibe Análisis Semanales Gratis",
  subscribeDesc: "Cada viernes — Top 5 partidos con estadísticas.",
  yourEmail: "Tu email",
  subscribe_btn: "Suscribirse Gratis",
  worldCup: "Copa del Mundo FIFA 2026",
  daysAway: "días restantes",
  viewQualifiers: "Ver Clasificatorias",
  featuredMatches: "🔥 Grandes Partidos",
  favourite: "Equipos Favoritos",
  addFav: "Añadir a favoritos",
  removeFav: "Quitar de favoritos",
  kickoff: "Inicio",
  stadium: "Estadio",
  season: "Vista Previa de Temporada",
  loading: "Cargando partidos...",
  avgScored: "Promedio Marcados",
  avgConceded: "Promedio Recibidos",
};
export default es;